import { t } from "i18next";

import TitledPage from "@/modules/common/components/layout/pages/TitledPage";

const ProductsPage = () => {
  return <TitledPage title={t("Admin Products")}></TitledPage>;
};

export default ProductsPage;
